document.addEventListener('DOMContentLoaded', function (dom) {
    const versus = dom.target.querySelector('.js-versus')
    function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }

    function setP(percent){
        p = clamp(percent, 0, 100);
        versus.style.setProperty("--p", p + "%");
    }

    function percentFromClientX(clientX){
        const r = versus.getBoundingClientRect();
        const x = clamp(clientX - r.left, 0, r.width);
        return (x / r.width) * 100;
    }

    if(versus){
        versus.addEventListener("pointerdown", (e) => {
            if (e.button === 2) return;
            versus.setPointerCapture(e.pointerId);
            setP(percentFromClientX(e.clientX));
        });

        versus.addEventListener("pointermove", (e) => {
            if (e.button === 2) return;
            if (!versus.hasPointerCapture(e.pointerId)) return;
            setP(percentFromClientX(e.clientX));
        });

        versus.addEventListener("pointerup", (e) => {
            if (e.button === 2) return;
            if (versus.hasPointerCapture(e.pointerId)) versus.releasePointerCapture(e.pointerId);
        });
    }
})
